import { render, staticRenderFns } from "./CreateIABFDancer.vue?vue&type=template&id=d00cc790&scoped=true"
import script from "./CreateIABFDancer.vue?vue&type=script&lang=js"
export * from "./CreateIABFDancer.vue?vue&type=script&lang=js"
import style0 from "./CreateIABFDancer.vue?vue&type=style&index=0&id=d00cc790&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d00cc790",
  null
  
)

export default component.exports